import { render, staticRenderFns } from "./TradiqueLayout.vue?vue&type=template&id=733ecd4a&"
import script from "./TradiqueLayout.vue?vue&type=script&lang=js&"
export * from "./TradiqueLayout.vue?vue&type=script&lang=js&"
import style0 from "./TradiqueLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733ecd4a')) {
      api.createRecord('733ecd4a', component.options)
    } else {
      api.reload('733ecd4a', component.options)
    }
    module.hot.accept("./TradiqueLayout.vue?vue&type=template&id=733ecd4a&", function () {
      api.rerender('733ecd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/TradiqueLayout.vue"
export default component.exports